export const getDeviceMode = (state) => {
  return state.VNMode.get('mode')
}

/**
 * @deprecated use getDeviceId from utils/deviceData
 */
export const getDeviceId = (state) => {
  return state.VNMode.get('deviceId')
}

/**
 * @deprecated use localStorage.getItem('accessToken') and localStorage.getItem('expiresAt') directly
 */
export const getPorticoAuthTokens = (state) => {
  return state.VNMode.get('porticoAuthTokens')
}

export const getSummitMode = (state) => {
  return state.VNMode.get('summit')
}
